export default __webpack_public_path__ + "static/media/wallet-magenta-bg.9f860fcd.svg";